import React, { useState, useEffect } from "react";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { roles } from "../../utils/constants";
import { useSelector } from "react-redux";
import { Toast } from "../../shared/Toast";
import { SlDrawer, SlButton,SlIcon } from "@shoelace-style/shoelace/dist/react";
import PreviewFrameEdit from "../PreviewFrameEdit";
import Paginator from "../../shared/Paginator";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import config from "../../config";

export const BlockedAdContext = React.createContext();
function Blocked() {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [campPreview, setCampPreview] = useState({ hdl: "", bdy: "", img: "", adv:"", adt_cls:"",count:0  });
  const [clickindex, setClickIndex] = useState(-1);
  const [currentPage, setCurrentPage] = useState(1);

  const [totalRecords, setTotalRecords] = useState(0);
  const Networkdate = useSelector((state) => state.Head.network_ads_date);
  const NetworkAdType = useSelector((state) => state.Head.network_ad_type);
  const NetworkAdSearch = useSelector((state) => state.Head.network_ad_search)

  const fetchData = async (page) => {
    try {
      setLoader(true);
      const res = await api({
        url: `/networkads/blocked`,
        method: "POST",
        responseType: "json",
        data: {
          date: Networkdate,
          type: NetworkAdType,
          search:NetworkAdSearch,
          limit:config.PER_PAGE,
          offset: (page - 1) * config.PER_PAGE,
        },
      });
      if (res.code === 200) {
        setData(res?.data?.result);
        setTotalRecords(res?.data?.totalRecords);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };

  const loadMoreData = async (offset) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/networkads/blocked`,
        method: "POST",
        responseType: "json",
        data: {
          date: Networkdate,
          type: NetworkAdType,
          search:NetworkAdSearch,
          limit: config.PER_PAGE, 
          offset:offset  ,
        },
      });
      if (res.code === 200) {
        console.log(res.data)
        setData((prevData) => [...prevData, ...res.data.result]);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };
  const loadPrevData = async (offset) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/networkads/blocked`,
        method: "POST",
        responseType: "json",
        data: {
          date: Networkdate,
          type: NetworkAdType,
          search:NetworkAdSearch,
          limit: config.PER_PAGE, 
          offset:offset  ,
        },
      });
      if (res.code === 200) {
        setClickIndex(res.data.result.length)
        console.log(clickindex)
        setData((prevData) => [...res.data.result, ...prevData]);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };
  const handleShowPreview = () => {
    setShow(true);
  };
  const handlePrevClick = ()=>{
    if(currentPage > 1){
      loadPrevData((currentPage -2) * config.PER_PAGE)
      setCurrentPage(prevPage => prevPage - 1)
    }
  }
  const handleClose = () => {
    setShow(false);
    fetchData(1)
    setCurrentPage(1)
  };
  const handleNextClick = () => {
    if(clickindex ===  data.length -2 ){
      if (currentPage < Math.ceil(totalRecords / config.PER_PAGE)) {
        if(currentPage !== 1)
        loadMoreData(((currentPage -1)  * config.PER_PAGE )+  data.length);
        else{
          loadMoreData(data.length)
        }
      }
    }
  };
  const removeFromData = async (index, operation) => {
    let id = data[index]["_id"];
    try {
      let res = await api({
        url: `/networkads/update`,
        method: "POST",
        responseType: "json",
        data: {
          id: id,
          status: operation === "approve" ? 1 : 2,
        },
      });
      if (res.code === 200) {
        if (index >= 0 && index < data.length) {
          const newData = data.filter((_, i) => i !== index);
          setData(newData);
          if (index === data.length - 1) {
            setClickIndex((prevIndex) => Math.max(0, prevIndex - 1));
          } else {
            setClickIndex(index);
          }
        } else {
          return;
        }
        Toast(
          "success",
          `${operation === "approve" ? "Approve" : "Blocked"} Successfully`
        );
        handleNextClick()
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
    fetchData(selectedPage);
  };
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== roles.network_ad_manager) navigate("/pagenotfound");
    fetchData(1);
    setCurrentPage(1)
  }, [Networkdate, NetworkAdType,NetworkAdSearch]);

  useEffect(() => {
    setCampPreview(data[clickindex]);
  }, [clickindex, data]);

  const handleClickhdl = async() => {
    if (campPreview?.adv) {
      await navigator.clipboard.writeText(campPreview.adv)
      Toast('success', "Advertiser Copied")
    }
  };
  return (
    <>
      <SlDrawer
        label="Blocked Network Ads"
        open={show}
        onSlAfterHide={handleClose}
        style={{ "--size": "100vw" }}
      >
        <div className="flex flex-row">
          <div className="w-3/12"></div>
          <div className="w-1/12 mb-auto" style={{ marginTop: "298px" }}>
            <SlButton
              disabled={clickindex === 0 || data.length === 0 ? true : false}
              onClick={() => {
                setClickIndex((prevIndex) => prevIndex - 1);
                if(clickindex === 1){
                  handlePrevClick()
                }
              }}
              variant="neutral"
            >
              Prev
            </SlButton>
          </div>
          <div className="w-4/12">
            <BlockedAdContext.Provider value={{ campPreview }}>
              <PreviewFrameEdit showPreview={show} />
            </BlockedAdContext.Provider>
          </div>
          <div className="w-1/12 my-auto ">
            <SlButton
              disabled={
                clickindex === data.length - 1 || data.length === 0
                  ? true
                  : false
              }
              onClick={() => {
                setClickIndex((prevIndex) => prevIndex + 1);
                handleNextClick()
              }}
              variant="neutral"
            >
              Next
            </SlButton>
            <div className="flex flex-col w-auto py-3">
              <SlButton
                className="w-16 py-1"
                title="Approve"
                disabled={data.length > 0 ? false : true}
                onClick={() => {
                  removeFromData(clickindex, "approve");
                }}
                variant="success"
              >
                &#10004;
              </SlButton>
              {/* <SlButton className="w-16 py-1" title="Block" onClick={()=> removeFromData(clickindex, 'block')} variant="danger">
                &#10008;
              </SlButton> */}
            </div>
          </div>
          <div className="w-3/12 m-auto">
          <div className="font-medium text-lg ">
          <>
              {
                `Advertiser:  ${campPreview?.adv}`
              }
              {" "}
              <SlIcon name="files" library="lucide" onClick={handleClickhdl} className="hover:cursor-pointer" title="Copy Title"></SlIcon></>
            </div>
            <div className="font-medium text-lg ">
            {
                `Source:  ${campPreview?.adt_cls.includes('facebook') ? 'Facebook' : 'Google'}`
              }
            </div>
            <div className="font-medium text-lg ">
                {
                  `Impressions: ${campPreview?.count === null ? 1 : campPreview?.count}`
                }
            </div>
          </div>
        </div>
      </SlDrawer>
      <div className="overflow-x-auto">
        <ScrollContainer>
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Source</th>
            <th>Advertiser</th>
            <th>Blocked By</th>
            <th>Impressions</th>
          </tr>
        </thead>
        {data?.length && !loader ? (
          <tbody>
            {data.map((item, index) => {
              return (
                <tr
                  key={index}
                  className="hover:cursor-pointer"
                  onClick={() => {
                    handleShowPreview();
                    setClickIndex(index)
                  }}
                >
                  <td>{item.hdl || "-"}</td>
                  <td>{item.bdy?.replace('/$', '$') || "-"}</td>
                  <td>
                    {item.adt_cls?.includes("facebook") ? "Facebook" : "Google"}
                  </td>
                  <td>{item.adv || "-"}</td>
                  <td>{item.name || "-"}</td>
                  <td>{item.count === null ? 1 : item.count}</td>
                </tr>
              );
            })}
          </tbody>
        ) : !data?.length && !loader ? (
          <NoDataFound colspan="8" />
        ) : (
          <TableLoader colspan="8" />
        )}
      </table>
      </ScrollContainer>
      </div>
      <div className='flex justify-end'>
      {data?.length && totalRecords > 0 && currentPage <= Math.ceil(totalRecords / config.PER_PAGE) ? (
          <Paginator
            pageCount={Math.ceil(totalRecords / config.PER_PAGE)}
            handlePageClick={handlePageClick}
            forcePage={currentPage - 1}
          />
        ) : null}
      </div>
    </>
  );
}

export default Blocked;
